import { useEffect, useState } from "react";
// import { useRouter } from "next/navigation";
import classNames from "classnames";
import Button from "react-bootstrap/Button";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Modal from "react-bootstrap/Modal";
import Row from "react-bootstrap/Row";
import { useForm } from "react-hook-form";
import { getData, getData2, postData } from "../../../utils/api";
import Select from "react-select";
import "./InquiryFormModal.css";
// import SubitFormModal from "../Admission/E-brochure/SubitFormModal/SubitFormModal";
// import ErrorFormModal from "../Admission/E-brochure/ErrorFormModal/ErrorFormModal";
import axios from "axios";
import Cookies from "js-cookie"; // Import js-cookie
import { useNavigate } from "react-router-dom";
import Main_heading_holder from "../common_css/main_heading_holder/Main_heading_holder";
const InquiryFormModal = (props) => {
  const {
    register,
    handleSubmit,
    setValue,
    reset,
    formState: { errors },
  } = useForm();
  const [coursesdata, setCoursesdata] = useState([]);
  const [statedata, setStatedata] = useState([]);
  const [cityData, setCityData] = useState([]);
  const [modalsuccess, setModalsuccess] = useState(false);
  const [modalerror, setModalError] = useState(false);

  const router = useNavigate();

  const getCityData = async (id) => {
    try {
      const res = await getData2(`/districts?state_id=${id}`);
      if (res?.success) {
        setCityData(res?.data);
      }
    } catch (error) {
      console.error("Error fetching courses data:", error);
    }
  };

  const getcoursesdata = async () => {
    try {
      const res = await getData(
        "/without-login/ed-tech/courses/common/common-type/courses",
      );
      if (res?.success) {
        setCoursesdata(res?.data);
      }
    } catch (error) {
      console.error("Error fetching courses data:", error);
    }
  };

  const getstatedata = async () => {
    try {
      const res = await getData2("/states?country_id=1");
      if (res?.success) {
        setStatedata(res?.data);
      }
    } catch (error) {
      console.error("Error fetching courses data:", error);
    }
  };

  useEffect(() => {
    getcoursesdata();
    getstatedata();
  }, []);

  const onSubmit = async (data) => {
    try {
      const selectedCourse = coursesdata.find(
        (course) => course.id === Number(data.course_id),
      );
      const courseName = selectedCourse ? selectedCourse.name : "Not Found";

      const finalData = new FormData();
      finalData.append("name", data?.name);
      finalData.append("email", data?.email);
      finalData.append("mobile", data?.contact_no);
      finalData.append("course_name", courseName);
      finalData.append("message", data?.message);
      finalData.append("state_id", data?.state_id);
      finalData.append("district_id", data?.district_id);
      finalData.append("api_key", process.env.REACT_APP_API_KEY);
      // finalData.append("source_name", "Profcyma_Website_Organic_Lead_Home");
      // finalData.append("source_name", "GoogleAds_DY_Profcyma_Mba");
      finalData.append("source_name", "Atlas_University_Google_Ads");

      const remark = `${data?.message} - Course: ${courseName}`;
      finalData.append("remark", remark);

      const response = await axios.post(
        `${process.env.REACT_APP_CRM_URL}/website-lead`,
        finalData,
        {
          headers: { "Content-Type": "multipart/form-data" },
        },
      );

      const res = await postData("/without-login/ed-tech/inquiry", {
        ...data,
        course_name: courseName,
      });

      if (res?.success) {
        const link = document.createElement("a");
        link.href = "/assets/images/MBA Brochure.pdf"; // Path to your brochure in public folder
        link.download = "MBA Brochure.pdf"; // File name for user
        link.click();

        Cookies.set("inquirySubmitted", true, { expires: 7 });
        reset();
        setModalsuccess(true);

        props.onHide();

        setTimeout(() => {
          setModalsuccess(false);
          router("/thank-you/");
        }, 3000);
      } else {
        console.error("Error response:", res);
      }
    } catch (error) {
      console.error("Error submitting inquiry:", error);
    }
  };

  const handleManualClose = () => {
    Cookies.set("inquiryClosed", "true", { expires: 1 }); // 1-day safety
    props.onHide();
  };

  const courseOptions = coursesdata?.map((item) => ({
    value: item.id,
    label: item.name,
  }));

  const stateOptions = statedata?.map((item) => ({
    value: item.id,
    label: item.name,
  }));

  const cityOptions = cityData?.map((item) => ({
    value: item.id,
    label: item.name,
  }));

  return (
    <>
      <Modal
        className="inquiry-form-modal modal-dialog-scrollable"
        centered
        {...props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        scrollable
        show={props.show}
        onHide={handleManualClose}
      >
        <Modal.Header className="modal-header-centered" closeButton>
          <Main_heading_holder heading={"  Inquiry "} spanHeading={"Form"} />
        </Modal.Header>
        <Modal.Body>
          <div className="form-sec-start Common_Form">
            <div className="row">
              <span>*Please fill the details below completely</span>
            </div>
            <Form onSubmit={handleSubmit(onSubmit)}>
              <Row className="form-detail">
                <Col md={6}>
                  <Form.Group controlId="formGridname" className="mb-3">
                    <Form.Label>Full Name</Form.Label>
                    <Form.Control
                      name="name"
                      className={classNames("", {
                        "is-invalid": errors?.name,
                      })}
                      type="text"
                      {...register("name", {
                        required: "Name is required",
                        pattern: {
                          value: /^[A-Za-z ]*$/,
                          message: "Name must contain only letters",
                        },
                      })}
                      onKeyDown={(event) => {
                        if (!/[A-Z-a-z ]/.test(event.key)) {
                          event.preventDefault();
                        }
                      }}
                      placeholder="Enter Full Name"
                    />

                    {errors?.name && (
                      <div className="invalid-feedback">
                        {errors.name.message}
                      </div>
                    )}
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group controlId="formGridphone" className="mb-3">
                    <Form.Label>Mobile Number</Form.Label>
                    <Form.Control
                      className={classNames("", {
                        "is-invalid": errors?.contact_no,
                      })}
                      type="tel"
                      {...register("contact_no", {
                        required: "Contact No Number is required",
                        pattern: {
                          value: /^\d{10}$/,
                          message:
                            "Contact No number must be a 10-digit number",
                        },
                        maxLength: 10,
                      })}
                      onKeyDown={(event) => {
                        const key = event.key;
                        if (
                          !/^\d$/.test(key) &&
                          ![
                            "Backspace",
                            "Delete",
                            "ArrowLeft",
                            "ArrowRight",
                            "Tab",
                            "Home",
                            "End",
                          ].includes(key)
                        ) {
                          event.preventDefault();
                        }
                      }}
                      placeholder="Enter Mobile Number"
                      maxLength={10}
                    />
                    {errors?.contact_no && (
                      <div className="invalid-feedback">
                        {errors.contact_no.message}
                      </div>
                    )}
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group controlId="formGridemail" className="mb-3">
                    <Form.Label>Email Address</Form.Label>
                    <Form.Control
                      className={classNames("", {
                        "is-invalid": errors?.email,
                      })}
                      type="email"
                      {...register("email", {
                        required: "E-mail is required",
                        pattern: {
                          value: /^([A-Za-z0-9_\-\.])+\@(?!(?:[A-Za-z0-9_\-\.]+\.)?([A-Za-z]{2,4})\.\2)([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/,
                          message: "Invalid E-Mail Address",
                        },
                      })}
                      placeholder="E-Mail"
                    />
                    {errors?.email && (
                      <div className="invalid-feedback">
                        {errors.email.message}
                      </div>
                    )}
                  </Form.Group>
                </Col>
                <Col sm={6}>
                  <Form.Group controlId="formGridcourse" className="mb-3">
                    {/* <Form.Label>Courses</Form.Label> */}
                    <div
                      className={classNames("react-select-wrapper", {
                        "is-invalid": errors?.course_id,
                      })}
                    >
                      <Select
                        options={courseOptions}
                        placeholder="Select Course"
                        onChange={(selected) => {
                          setValue("course_id", selected?.value);
                        }}
                      />
                    </div>
                    {errors?.course_id && (
                      <div className="invalid-feedback">
                        {errors.course_id.message}
                      </div>
                    )}
                  </Form.Group>
                </Col>

                <Col sm={6}>
                  <Form.Group controlId="formGridcourse" className="mb-3">
                    {/* <Form.Label>State</Form.Label> */}

                    <div
                      className={classNames("react-select-wrapper", {
                        "is-invalid": errors?.state_id,
                      })}
                    >
                      <Select
                        options={stateOptions}
                        placeholder="Select State"
                        onChange={(selected) => {
                          setValue("state_id", selected?.value);
                          getCityData(selected?.value);
                        }}
                      />
                    </div>

                    {errors?.state_id && (
                      <div className="invalid-feedback">
                        {errors.state_id.message}
                      </div>
                    )}
                  </Form.Group>
                </Col>

                <Col sm={6}>
                  <Form.Group controlId="formGridcourse" className="mb-3">
                    {/* <Form.Label>District</Form.Label> */}

                    <div
                      className={classNames("react-select-wrapper", {
                        "is-invalid": errors?.district_id,
                      })}
                    >
                      <Select
                        options={cityOptions}
                        placeholder="Select District"
                        onChange={(selected) => {
                          setValue("district_id", selected?.value);
                        }}
                      />
                    </div>
                    {/* <Form.Select
                aria-label="Default select example"
                className={classNames("", {
                  "is-invalid": errors?.district_id,
                })}
                {...register("district_id", {
                  required: "Please select a Course",
                })}
              >
                <option value="">Select District</option>
                {cityData?.map((item, index) => (
                  <option key={index} value={item?.id}>
                    {item?.name}
                  </option>
                ))}
              </Form.Select> */}
                    {errors?.district_id && (
                      <div className="invalid-feedback">
                        {errors.district_id.message}
                      </div>
                    )}
                  </Form.Group>
                </Col>

                <Col md={12}>
                  <Form.Group controlId="formGridmessage" className="mb-3">
                    <Form.Label>Message</Form.Label>
                    <Form.Control
                      className={classNames("", {
                        "is-invalid": errors?.message,
                      })}
                      {...register("message", {
                        required: "Message is required",
                      })}
                      as="textarea"
                      rows={3}
                    />
                    {errors?.message && (
                      <div className="invalid-feedback">
                        {errors.message.message}
                      </div>
                    )}
                  </Form.Group>
                </Col>
                <Col md={12}>
                  <Form.Group className="mb-3">
                    <Form.Check
                      required
                      name="group1"
                      type="checkbox"
                      id="authorizeMsg"
                      label={
                        <label htmlFor="authorizeMsg">
                          I hereby authorize you to send notifications via
                          SMS/RCS Messages/Promotional/Informational Messages
                        </label>
                      }
                    />
                  </Form.Group>
                </Col>
              </Row>
              <div className="button-holder text-center mb-5">
                <Button className="btn apply-btn me-3" type="submit">
                  Apply
                </Button>
              </div>
            </Form>
          </div>
        </Modal.Body>
      </Modal>
      {/* <SubitFormModal
        show={modalsuccess}
        onHide={() => {
          setModalsuccess(false);
          router.replace("/thank-you");
        }}
      /> */}
      {/* <ErrorFormModal
        show={modalerror}
        onHide={() => {
          setModalError(false);
        }}
      /> */}
    </>
  );
};

export default InquiryFormModal;
